module.exports = __webpack_public_path__ + "img/magento-security-services_medium.c90a47c1.webp";